import { render, staticRenderFns } from "./UpdateClaimPartial.vue?vue&type=template&id=3bfed6d8"
import script from "./UpdateClaimPartial.vue?vue&type=script&lang=js"
export * from "./UpdateClaimPartial.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports